import styled from 'styled-components';

import { flexAllCenter } from 'styles/mixins';
import { COLORS, hexWithOpacity } from 'styles/style-constants';

export const SwitchGroup = styled.fieldset`
    display: inline-flex;
    flex-shrink: 0;
    gap: 0.4rem;
    margin: 0;
    padding: 0.4rem;
    border: 0.1rem solid ${COLORS.gray100};
    border-radius: 2.4rem;
    background: ${COLORS.gray50};
`;

export const HiddenLabel = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
`;

export const Option = styled.label`
    position: relative;
    cursor: pointer;

    input {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        cursor: pointer;

        &:focus-visible {
            outline: none !important;
        }
    }

    span {
        ${flexAllCenter};
        width: 3.6rem;
        height: 3.2rem;
        border-radius: 1.8rem;
        color: ${COLORS.textGray};
        transition:
            background 150ms ease,
            color 150ms ease,
            box-shadow 150ms ease;
    }

    &:hover span {
        color: ${COLORS.textPrimary};
        background: ${COLORS.gray100};
    }

    input:checked + span {
        color: ${COLORS.purple500};
        background: ${COLORS.surface};
        box-shadow: 0 0.1rem 0.4rem ${hexWithOpacity(COLORS.shadow, 12)};
    }

    input:focus-visible + span {
        outline: 0.2rem solid ${COLORS.purple500};
        outline-offset: 0.2rem;
    }
`;
